var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"themeItem_scheduleDetail_baseInfor"},[_c('SCHEDULEDETAIL_BASEINFOR',{attrs:{"CSMeetScheduleInfo":_vm.currMatchDetailInfor}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }